var map = {
	"./ProofMenu.png": "e59d",
	"./QXInvestment.png": "f22f",
	"./approvalProcess.png": "9c07",
	"./attendance.png": "9235",
	"./auditReport.png": "b398",
	"./dataInput.png": "8fa1",
	"./incomeProofMenu.png": "84d7",
	"./meritDataManagement.png": "4ecf",
	"./organization.png": "a1c7",
	"./paid.png": "957e",
	"./payroll.png": "a69f",
	"./payslip.png": "9bae",
	"./personnelManagement.png": "d546",
	"./policy.png": "d66a",
	"./policyLibrary.png": "59fc",
	"./policyLibraryManagement.png": "0c5b",
	"./process.png": "b419",
	"./seagateFile.png": "a89d",
	"./service.png": "c4dc",
	"./settings.png": "7c62",
	"./sishangReport.png": "7534",
	"./statistics.png": "5b7c",
	"./stockExerciseEmail.png": "bdf2",
	"./teslaCustom.png": "e17c",
	"./teslaCustomData.png": "63cb",
	"./teslaPayAccount.png": "4cb5",
	"./workbench.png": "7527"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92b8";